import HttpMethods from "../../../Services/httpMethods";
import { makeRequest } from "../../../Services/restcall";
import { ApiResponse } from "../../../Services/types";
import type { CreatePedidoRequest } from "./types";

export async function createPedidoAPI(value: CreatePedidoRequest): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.POST, '/api/commerce/create-pedido', value)
}

export async function confirmarPagoAPI(pagoId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.PUT, '/api/commerce/confirmar-pago?pagoId=' + pagoId, {})
}

export async function rechazarPagoAPI(pagoId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.PUT, '/api/commerce/rechazar-pago?pagoId=' + pagoId, {})
}

export async function cancelarPedidoAPI(pedidoId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.PUT, '/api/commerce/cancelar-pedido?pedidoId=' + pedidoId, {})
}

export async function cancelarMiPedidoAPI(pedidoId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.PUT, '/api/commerce/cancelar-mi-pedido?pedidoId=' + pedidoId, {})
}

export async function marcarEntregadoAPI(pedidoId: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.PUT, '/api/commerce/marcar-entregado?pedidoId=' + pedidoId, {})
}

export async function getAllPedidosAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.GET, '/api/commerce/pedidos', {})
}

export async function getMisPedidosAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.GET, '/api/commerce/mis-pedidos', {})
}

export async function getPedidoByIdAPI(id: string): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.GET, '/api/commerce/pedido-id', { id })
}
